import { GET, POST, PATCH, DELETE } from '@/utils/axios'
import axios from 'axios'
import cache from '@/utils/cache'

const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}

export const getValidatedByList = async () =>
  await GET('/users/validators', { useAuthorization: true })

export const getValidationsList = async (
  searchedData,
  query,
  page,
  limit,
  id
) =>
  await POST(
    `/survey/enrollments/${id}?search=${searchedData}&page=${page}&size=${limit}`,
    query,
    {
      useAuthorization: true
    }
  )

export const getValidationsListCount = async (
  searchedData,
  query,
  page,
  limit,
  id
) =>
  await POST(
    `/survey/enrollments/count/${id}?search=${searchedData}&page=${page}&size=${limit}`,
    query,
    {
      useAuthorization: true
    }
  )

export const getEnrollmentAnswers = async (id, surveyId) => {
  const response = await POST(
    `/survey-enrollment/answers/${id}`,
    { surveyId },
    {
      useAuthorization: true
    }
  )
  return response.data?.data
}

export const updateEnrollment = async (id, payload) => {
  const response = await PATCH(`/survey-enrollment/${id}`, payload, {
    useAuthorization: true
  })
}

export const getSurveyProductsReceipts = async id => {
  const data = await POST(`/survey/products/${id}`, null, {
    useAuthorization: true
  })
  return data.data
}

export const getProductsReceipts = async (surveyId, prodId, tab) => {
  const data = await POST(
    `/survey/products-receipts?survey=${surveyId}&product=${prodId}&receipts=${tab}`,
    null,
    {
      useAuthorization: true
    }
  )
  return data.data
}

export const createDuplicate = async payload => {
  const data = await POST('/validation-duplicates', payload, {
    useAuthorization: true
  })
  return data.data
}

export const deleteDuplicate = async duplicateId => {
  const data = await DELETE(`/validation-duplicates/${duplicateId}`, {
    useAuthorization: true
  })
  return data.data
}

export const checkProductUsers = async payload => {
  const data = await POST(
    '/survey-enrollment/update-enrolment-approval',
    payload,
    {
      useAuthorization: true
    }
  )
  return data.data
}

export const markEntry = async payload => {
  const data = await POST('/survey-enrollment/update-enrollments', payload, {
    useAuthorization: true
  })
  return data.data
}

export const markEntryForReceipts = async payload => {
  const data = await POST('/survey-enrollment/update-receipts', payload, {
    useAuthorization: true
  })
  return data.data
}

export const getValidationLogs = async id => {
  const response = await GET(`/validation-logs/${id}`, {
    useAuthorization: true
  })
  return response.data
}

export const exportMediaAnswerMarking = async (surveyId, surveyName) => {
  const token = cache.getItem('flavorwiki-validation-token')
  const response = await axios.get(
    `/media-answer-marking/export/${surveyId}`,
    {
      baseURL: process.env.REACT_APP_BACKEND_API_URL,
      headers: {
        Authorization: `Bearer ${token}`
      },
      responseType: 'blob'
    }
  )

  const safeName = (surveyName || surveyId).replace(/[^a-z0-9-_]+/gi, '-')
  downloadBlob(
    response.data,
    `media-answer-marking-${safeName}.xlsx`
  )
}
